import { PackPopupType } from '@nf/types/promotion';
import { RewardScene } from '@/types';
import { useReward } from '@/contexts/reward-context';
import { RewardModalWrapper } from '@/components/reward-modal-wrapper';

export const BeginnersPack = () => {
	const {
		labels,
		setRewardScene,
		onDismissPackPopup,
		onClose,
		onExclusiveKafkaSet
	} = useReward();

	const closePopup = () => {
		onDismissPackPopup?.(PackPopupType.Notify);
		onExclusiveKafkaSet({
			type: 1,
			action: 1
		});
		onClose();
	};

	const goToVouchersPage = () => {
		onDismissPackPopup?.(PackPopupType.Notify);
		onExclusiveKafkaSet({
			type: 1,
			action: 2
		});
		setRewardScene(RewardScene.MyVouchers);
	};

	return (
		<RewardModalWrapper>
			<div className="beginners-pack">
				<div className="beginners-pack__wrapper">
					<div className="beginners-pack__header">
						<div className="reward-gradient-text beginners-pack__header-title">
							{labels?.lbl_IDRRFLoginP01}
						</div>
						<div className="beginners-pack__header-subtitle">
							{labels?.lbl_IDRRFLoginP02}
						</div>
					</div>
					<div className="beginners-pack__content">
						<div className="beginners-pack__scene-1">
							<div className="beginners-pack-box">
								<div className="beginners-pack-box__boxes"></div>
								<div className="beginners-pack-box__box"></div>
								<div className="beginners-pack-box__lid"></div>
							</div>
							<div className="beginners-pack-light"></div>
						</div>
						<div className="beginners-pack__scene-2">
							<div className="beginners-pack-box-opened">
								<div className="beginners-pack-box-opened__ribbon"></div>
								<div className="beginners-pack-box-opened__light"></div>
							</div>
							<div className="beginners-pack-panel-gifts"></div>
							<div className="beginners-pack-panel">
								<div className="beginners-pack-panel__label">
									<div className="reward-gradient-text multi-line-ellipsis">{labels?.lbl_IDRRFLoginP03}</div>
								</div>
								<div className="beginners-pack-panel__voucher">
									<div className="beginners-pack-panel__voucher-icon">

										<i className="reward-icon-voucher-shield reward-icon-voucher--gift"></i>
										<div className="beginners-pack-panel__voucher-count">x1</div>
									</div>

									<div className="beginners-pack-panel__title">
										<div className="reward-gradient-text">{labels?.lbl_IDRRFLoginP04}</div>
									</div>
								</div>

								<div className="beginners-pack-panel__divider"></div>

								<div className="beginners-pack-panel__text">{labels?.lbl_IDRRFLoginP05}</div>
								<div className="beginners-pack-panel__bottons">
									<div 
										className="beginners-pack-btn beginners-pack-btn--normal"
										onClick={closePopup}
									>
										<div className="multi-line-ellipsis">{labels?.lbl_IDRRFLoginP06}</div>
									</div>
									<div 
										className="beginners-pack-btn beginners-pack-btn--action"
										onClick={goToVouchersPage}
									>
										<div className="multi-line-ellipsis">{labels?.lbl_IDRRFLoginP07}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</RewardModalWrapper>
	);
};